module.exports = __webpack_public_path__ + "img/IMG_1458_L_Black_MockedUp.416282dc.jpg";